import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import homeSolid from '!!svg-inline-loader?classPrefix!src/assets/home-solid.svg';
import Layout from './Layout';

export default function NotFound() {
  return (
    <Layout>
      <Helmet>
        <title>Means88 | Not found</title>
      </Helmet>
      <img
        width={256}
        height={272}
        className="dark:opacity-75 mx-auto mt-3"
        src="/404.png"
        alt="not found"
      />
      <h1 className="text-4xl text-center mt-6">404</h1>
      <div className="text-center mt-8 md:mt-12 lg:mt-16">
        <Link to="/" className="w-32 btn-primary uppercase">
          <span
            className="fill-current inline-block align-middle"
            dangerouslySetInnerHTML={{
              __html: homeSolid,
            }}
            style={{ width: '1em', height: '1em' }}
          />
          &nbsp;&nbsp;
          <span className="align-middle">Home</span>
        </Link>
      </div>
    </Layout>
  );
}
